module.exports = __webpack_public_path__ + "fonts/iconfont.6c667776.eot";